import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { ColorThemeService } from '@core/theming/color-theme.service';

/**
 * Instantiates the {@link ColorThemeService} during bootstrap so persisted
 * color choices are applied even before any component asks for them.
 *
 * `assets/js/color-theme-boot.js`, loaded from `index.html`, already puts the colors
 * in place before the first paint; this only hands ownership of that style element
 * to the service.
 **/
export function provideColorTheme(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      inject(ColorThemeService);
    }),
  ]);
}
